'use client'

import { Fragment, useEffect, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import Input from '@/components/v1/ui/input/input'
import { ButtonOutLineWithBorder } from '@/components/v1/ui/button/buttonWithSpin'
import {
  ButtonControl,
  ChevronDown,
  CollapeContent,
  ReferenceContainer,
  SupplierActionBarStyle,
  SupplierSectionStyle,
  Trash,
  WrappAction,
} from '@/components/v1/page-style/admin/editor-console/content/widget/widget.style'
import { Label } from '@/components/v1/ui/input/input.label.style'
import { SupplierReferenceType } from '@/components/v3/unique/article/supplier-reference/supplier-reference'
import { Checkbox } from '@/components/v2/atoms/checkbox/checkbox'
const prefix = 'https://'

const SupplierSection = ({
  item,
  onDelete,
  onChange,
}: {
  item: SupplierReferenceTypeWithId
  onDelete: (id: string) => void
  onChange: (updatedItem: SupplierReferenceTypeWithId) => void
}) => {
  const [toggle, setToggle] = useState<boolean>(false)

  const onChangeAction = (value: Partial<SupplierReferenceType>) => {
    if (onChange)
      onChange({
        ...item,
        ...value,
      })
  }

  const addPrefix = (value: string) => {
    const link = value.indexOf('://') === -1 ? `${prefix}${value}` : value
    onChangeAction({ url: value ? link : '' })
  }

  return (
    <SupplierSectionStyle>
      <SupplierActionBarStyle>
        <WrappAction>
          <Label>Suppliers</Label>
        </WrappAction>
        <WrappAction>
          <ButtonControl onClick={() => setToggle(!toggle)}>
            <ChevronDown />
          </ButtonControl>
          <ButtonControl onClick={() => onDelete(item.id)}>
            <Trash />
          </ButtonControl>
        </WrappAction>
      </SupplierActionBarStyle>
      <CollapeContent toggle={toggle}>
        <Input
          name={`name-${item.id}`}
          type="text"
          label="Name"
          placeholder="Enter name here"
          onChange={(value: string) => onChangeAction({ name: value })}
          value={item.name}
        />
        <Input
          name={`category-${item.id}`}
          type="text"
          label="Category"
          placeholder="Enter Category here"
          value={item.category}
          onChange={(value: string) => onChangeAction({ category: value })}
        />
        <Checkbox
          label="No Follow"
          checked={item.nofollow ?? false}
          onChange={(e) => {
            onChangeAction({ nofollow: e })
          }}
        />

        <Checkbox
          label="Sponsored"
          checked={item.sponsored ?? false}
          onChange={(e) => {
            onChangeAction({ sponsored: e })
          }}
        />
        <Input
          name={`url-${item.id}`}
          type="text"
          label="URL"
          onBlur={addPrefix}
          value={item.url}
          placeholder="Enter full url eg. https://--"
          onChange={(value: string) => onChangeAction({ url: value })}
        />
      </CollapeContent>
    </SupplierSectionStyle>
  )
}

type SupplierReferenceTypeWithId = SupplierReferenceType & { id: string }

const ReferanceEditor = ({
  defaultValue,
  onChange,
}: {
  defaultValue?: SupplierReferenceType[]
  onChange?: (value: SupplierReferenceType[]) => void
}) => {
  const [suppliers, setSupplier] = useState<SupplierReferenceTypeWithId[]>([])

  const addNewSupplier = (e: any) => {
    e.preventDefault()
    const id = uuidv4()
    setSupplier((prevState) => [
      ...prevState,
      {
        id: id,
        name: '',
        url: '',
        category: '',
      },
    ])
  }

  const onDelete = (id: string) => {
    const newList = suppliers.filter((item) => item.id !== id)
    setSupplier(newList)
  }

  const onUpdateSupplier = (updatedItem: SupplierReferenceTypeWithId) => {
    const prevData = suppliers.find((item) => item.id === updatedItem.id)
    const dataIndex = suppliers.findIndex((item) => item.id === updatedItem.id)
    suppliers[dataIndex] = { ...prevData, ...updatedItem }
    const newSupplier = [...suppliers]
    setSupplier(newSupplier)
  }

  useEffect(() => {
    if (onChange) {
      const suppliersWithoutId = suppliers.map((item) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { id, ...rest } = item
        return rest
      })
      onChange(suppliersWithoutId)
    }
  }, [suppliers])

  useEffect(() => {
    if (defaultValue) {
      const suppliersWithId = defaultValue.map((item) => {
        const id = uuidv4()
        return {
          ...item,
          id: id,
        }
      })
      setSupplier(suppliersWithId)
    }
  }, [])

  return (
    <Fragment>
      <ReferenceContainer>
        {Array.isArray(suppliers) &&
          suppliers.map((item, key) => (
            <SupplierSection
              item={item}
              key={key}
              onDelete={onDelete}
              onChange={onUpdateSupplier}
            />
          ))}
      </ReferenceContainer>
      <ButtonOutLineWithBorder
        label="+Add"
        onClick={addNewSupplier}
        containerStyle={{ width: 150, margin: 0 }}
      />
    </Fragment>
  )
}

export default ReferanceEditor
